function Doprava_d_p_II(){
    return(
        <div>
            Doprava a distribucia plynov 2
        </div>

    );
};

export default Doprava_d_p_II;